import { createContext } from "react";

const ProfileComponentContext = createContext({});

export default ProfileComponentContext;
